import React, { useEffect } from "react";
import { Provider } from "react-redux";
import PropTypes from "prop-types";
import ErrorBoundary from "common/components/error-boundary";
import pathsService from "common/services/paths-service";
import CampaignGroupPropType from "account-app/features/campaigns/campaign-group-prop-type";
import ClientLanding from "./client-landing";
import ClientLandingStore from "./client-landing-store";

const propTypes = {
  clientLanding: PropTypes.shape({
    enabled: PropTypes.bool,
    campaignId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    accountId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    clientToken: PropTypes.string,
    presentingAgentName: PropTypes.string,
    agentPhotoUrl: PropTypes.string,
    clientName: PropTypes.string,
    agentSignInPath: PropTypes.string,
    appName: PropTypes.string,
    campaignGroup: CampaignGroupPropType,
    campaignResults: PropTypes.shape({
      campaignPackage: PropTypes.shape({
        packageLabel: PropTypes.string,
        packageDetails: PropTypes.string,
        startsAt: PropTypes.string,
        endsAt: PropTypes.string,
        newRenewalPlan: PropTypes.string,
        renewalDate: PropTypes.string
      }),
      destinationURL: PropTypes.string,
      targetingAreas: PropTypes.arrayOf(
        PropTypes.shape({ name: PropTypes.string, radius: PropTypes.number })
      ),
      vistarPostalCodes: PropTypes.arrayOf(
        PropTypes.shape({
          postalCode: PropTypes.string,
          count: PropTypes.number,
          category: PropTypes.string
        })
      ),
      uniqueContacts: PropTypes.number
    }),
    paths: PropTypes.shape({
      accountCampaignPerformancePath: PropTypes.string
    })
  }).isRequired
};

const ClientLandingApp = ({ clientLanding }) => {
  pathsService.add(clientLanding.paths || {});

  useEffect(() => {
    document.title = "Campaign Results - Adwerx";
  }, []);

  return (
    <Provider store={ClientLandingStore}>
      <ErrorBoundary log>
        <ClientLanding
          campaignResults={clientLanding.campaignResults}
          campaignGroup={clientLanding.campaignGroup}
          accountId={clientLanding.accountId}
          campaignId={clientLanding.campaignId}
          clientToken={clientLanding.clientToken}
          presentingAgentName={clientLanding.presentingAgentName}
          agentPhotoUrl={clientLanding.agentPhotoUrl}
          agentSignInPath={clientLanding.agentSignInPath}
          clientName={clientLanding.clientName}
          appName={clientLanding.appName}
        />
      </ErrorBoundary>
    </Provider>
  );
};

ClientLandingApp.propTypes = propTypes;

export default ClientLandingApp;
